import {
  Control, Controller, FieldPath, FieldValues,
} from "react-hook-form";
import { Label, ToggleSwitch, Spinner } from "flowbite-react";
import { P } from "@/shared/ui/typographies/paragraph";

type ControlledSwitchProps<T extends FieldValues> = {
  id: string
  label: string | React.ReactElement
  description?: string | React.ReactElement
  control: Control<T>
  name: FieldPath<T>
  dataTestId?: string
  isLoading?: boolean
  disabled?: boolean
};

export const ControlledSwitch = <T extends FieldValues>({
  id, label, description, control, name, dataTestId, isLoading = false, disabled = false, ...props
}: ControlledSwitchProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className="flex flex-col">
          <Label
            htmlFor={id}
            className="flex flex-row gap-1 items-center justify-between"
            data-testid={dataTestId}
          >

            {label}
            <div className="flex items-center gap-2">
              {isLoading && <Spinner size="md" />}
              <ToggleSwitch
                {...field}
                {...props}
                id={id}
                checked={field.value}
                onChange={field.onChange}
                disabled={disabled || isLoading}
              />
            </div>
          </Label>
          {description && <P className="text-xs">{description}</P>}
        </div>
      )}
    />
  );
};
